import { render, staticRenderFns } from "./customHeader.vue?vue&type=template&id=0cdce27f&scoped=true"
import script from "./customHeader.vue?vue&type=script&lang=js"
export * from "./customHeader.vue?vue&type=script&lang=js"
import style0 from "./customHeader.vue?vue&type=style&index=0&id=0cdce27f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdce27f",
  null
  
)

export default component.exports